module.exports = __webpack_public_path__ + "static/media/fooda.65629fe8.png";